import { createSlice } from '@reduxjs/toolkit';

interface State {
  isLoading: boolean;
  error: boolean;
  bulkUploadResponse: any;
  bulkUploadStatus: string;
}

const initialState: State = {
  isLoading: false,
  error: false,
  bulkUploadResponse: {},
  bulkUploadStatus: ""
};

export const bulkUploadSlice = createSlice({
  name: 'bulkUpload',
  initialState,
  reducers: {
    bulkUploadStart: (state: State, action) => ({
      ...initialState,
      isLoading: true
    }),
    startLoading: (state: State) => ({
      ...initialState,
      isLoading: true
    }),
    bulkUploadSuccess: (state: State, action) => ({
      ...state,
      isLoading: false,
      bulkUploadResponse: action.payload.bulkUploadResponse,
      bulkUploadStatus: action.payload.status
    }),
    bulkUploadFailure: (state: State) => ({
      ...state,
      error: true,
      isLoading: false,
    }),
    statusDismiss: (state: State) => ({
      ...initialState
    })
  }
});

export const {
    bulkUploadFailure,
    bulkUploadStart,
    startLoading,
    bulkUploadSuccess,
    statusDismiss
} = bulkUploadSlice.actions;
export default bulkUploadSlice.reducer;
